function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import classNames from 'classnames';
import React, { useState } from 'react';
import { getRandomInteger } from '../../utils/mathFunctions';
const TextInput = /*#__PURE__*/React.forwardRef(({
  label,
  value,
  children,
  defaultValue,
  inputClassName,
  hasError,
  id = `${getRandomInteger()}`,
  isDisabled,
  type = 'text',
  onFocus,
  onBlur,
  labelClassName,
  wrapperClassName,
  ...props
}, ref) => {
  const [isFocus, setIsFocus] = useState(false);
  const handleOnFocus = event => {
    setIsFocus(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  const handleOnBlur = event => {
    setIsFocus(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  const wrapperClassNames = classNames('relative', 'peer', `${label && 'pt-4'}`, `${wrapperClassName ?? ''}`);
  const inputClassNames = classNames('peer', 'block', 'w-full', 'py-2.5', 'px-0', 'text-lg', 'font-light', 'border', 'border-x-0', 'border-t-0', 'border-b-1', 'border-gray-300', `${hasError ? 'focus:border-red-600 focus:ring-0' : 'focus:border-kira-blue-300 focus:ring-0'}`, `${inputClassName ?? ''}`);
  const isFocusOrHasValue = isFocus || value || defaultValue;
  const labelClassNames = classNames(labelClassName ?? '', 'block', 'absolute', 'transition-all', 'font-light', {
    'text-kira-blue-300': isFocus
  }, {
    'text-slate-500': !isFocus && value
  }, `${isFocusOrHasValue ? '!text-sm top-0 cursor-auto' : '!text-xl top-6 cursor-text text-slate-800'}`, {
    'text-red-600': hasError
  });
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: labelClassNames
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("input", _extends({
    "data-testid": "text-input",
    className: inputClassNames,
    type: type,
    id: id,
    ref: ref,
    disabled: isDisabled,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur
  }, props, {
    defaultValue: defaultValue
  })), children));
});
export default TextInput;